import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-token-success-modal',
    templateUrl: './token-success-modal.component.html',
    styleUrls: ['./token-success-modal.component.scss'],
    standalone: false
})
export class TokenSuccessComponent implements OnInit {
  @Input() status: string = 'success'; // 'success' or 'cancelled'

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
  }

  close() {
    this.activeModal.close();
    
    if (this.status === 'char_success' || this.status === 'char_cancelled' || this.status === 'char_canceled') {
      window.close();
    }
  }
}
